/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiFrameSizeMaxIcon64Regular = forwardRef('UiFrameSizeMaxIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M40 8.5A1.5 1.5 0 0 1 41.5 7h7a8.5 8.5 0 0 1 8.5 8.5v7a1.5 1.5 0 0 1-3 0v-7a5.5 5.5 0 0 0-5.5-5.5h-7A1.5 1.5 0 0 1 40 8.5Z" }),
        React.createElement("path", { d: "M10 41.5a1.5 1.5 0 0 0-3 0v7a8.5 8.5 0 0 0 8.5 8.5h7a1.5 1.5 0 0 0 0-3h-7a5.5 5.5 0 0 1-5.5-5.5v-7Z" }),
        React.createElement("path", { d: "M57 41.5a1.5 1.5 0 0 0-3 0v7a5.5 5.5 0 0 1-5.5 5.5h-7a1.5 1.5 0 0 0 0 3h7a8.5 8.5 0 0 0 8.5-8.5v-7Z" }),
        React.createElement("path", { d: "M15.5 7A8.5 8.5 0 0 0 7 15.5v7a1.5 1.5 0 0 0 3 0v-7a5.5 5.5 0 0 1 5.5-5.5h7a1.5 1.5 0 0 0 0-3h-7Z" })));
});
